import React, { useContext, useRef, useState, useEffect } from "react";
import { AppContext } from "../Redux/ContextProvider";
import { ClipLoader } from "react-spinners";
import Breadcrumb from "../Generic/Breadcrumb";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { getCommonDetails } from "../Redux/API";

function FloorPlan() {
  const { appState, dispatch } = useContext(AppContext);
  const { common, homeLoader } = appState;
  const [loading, setLoading] = useState(true);
  const myRef = useRef(null);
  // console.log("image has to display", home.floorplan_image);
   const [isOpen, setIsOpen] = useState(false);
  const imageUrl = common?.floorplan_image;

   useEffect(() => {
    getCommonDetails(appState, dispatch);
  }, [dispatch]);

    useEffect(() => {
    if (imageUrl) {
      setLoading(false);
    }
  }, [imageUrl, common]);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = "floorplan.jpg";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

   const DownloadIco = (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5l5-5m-5-7v12" /></svg>
  );

    if (loading) {
    return (
      <div className="home-spinner">
        <ClipLoader
          color="#2A5350"
          loading={true}
          size={60}
        />
      </div>
    );
  }

  return (
    <>
   
          <Breadcrumb
            pageName="Floor Plan"
            pageTitle="Floor Plan"
            id=""
            image=""
            myRef={myRef}
          />
          <div ref={myRef}>
            <div className="service2-section mb-50">
              <div className="container">
                <div className="section-title2 primary3">
                  <span>Floor Plan</span>
                  <h2>Explore Our Floor Layouts</h2>
                </div>
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-12">
                    <div className="plan-item glass-effect">
                      <div className="image">
                        <img src={imageUrl} alt="Floorplan" className="img-fluid" />
                         <div className="zoom-icon" onClick={() => setIsOpen(true)} >
                          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314M11 8v6m-3-3h6" /></svg>
                        </div>

                      </div>
                       <div className='btn-wrap'>
                        <button
                          key="download"
                          onClick={handleDownload}
                          className='btn--primary2'
                        >
                          {DownloadIco} Download Floor Plan
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

             {isOpen && (
            <Lightbox
              mainSrc={imageUrl}
              onCloseRequest={() => setIsOpen(false)}
              enableZoom={true}
              toolbarButtons={[
                <button
                  key="download"
                  style={{
                background: "transparent",
                border: "none",
                color: "#fff",
                fontSize: "16px",
                cursor: "pointer"
              }}
                  onClick={handleDownload}
                >
                   {DownloadIco} Download
                </button>,
               ]}
            />
          )}  
        </>
  );
}
export default FloorPlan;
